<template>
  <div class="card">
    <div class="card-body">
      <b-table
        :items="erpOrders"
        :fields="erpOrdersHeaders"
        hover
        responsive
        :per-page="perPage"
        :busy="erpOrdersLoading"
        head-row-variant="info"
        table-variant="white"
        show-empty
      >
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{ scope.loading ? "Lütfen Bekleyin" : noOrderMessage }}
          </h6>
        </template>
        <template #cell(process)="data">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-1"
                  fab
                  text
                  x-small
                  color="primary darken-1"
                  v-bind="attrs"
                  v-on="on"
                  @click="openSiparisDetailDialog(data.item.orderNumber)"
                >
                  <v-icon dark> mdi-text-box-search </v-icon>
                </v-btn>
            </template>
            <span>Sipariş Detay Görüntüle</span>
          </v-tooltip>
        </template>
        <template #cell(totalAmount)="data">
          {{ numberConverter(data.item.totalAmount) }}
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner
              variant="primary"
              size="lg"
              label="Text Centered"
            ></b-spinner>
          </div>
        </template>
      </b-table>
      <OrderDetailsDialog
        :showDialog="orderDetailDialog"
        :orderNumber="orderNumber"
        :title="'Sipariş Detay'"
        @dialogChange="(e) => (orderDetailDialog = e)"
      ></OrderDetailsDialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import OrderDetailsDialog from "../dialogs/OrderDetailsDialog.vue";
import {numberConverter} from "../../../../../helpers";

export default {
  components: {
    OrderDetailsDialog,
  },
  props: {
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
  },

  computed: {
    ...mapState("order", ["erpOrders", "erpOrdersHeaders", "erpOrdersLoading","noOrderMessage"]),
  },
  data() {
    return {
      selectRow: false,
      orderDetailDialog: false,
      orderDetailDialogData: null,
      orderNumber: null
    };
  },
  methods: {
    numberConverter,
    openSiparisDetailDialog(orderNumber) {
      this.orderNumber = orderNumber;
      this.orderDetailDialog = true;
    },
  },
  watch: {},
};
</script>
